import { Sequence } from "./Sequence";

export class EmailTemplate {
    subject: string;
    message: string;

    constructor(
        subject: string = '',
        message: string = ''
    ){
        this.subject = subject;
        this.message = message;
    }
}

export class InvoiceTemplate {
    id: number | null;
    name: string;
    html: string;
    options: string;
    company_id: number | null;

    constructor(
        id: number | null = null,
        name: string = '',
        html: string = '',
        options: string = '',
        company_id: number | null = null
    ){
        this.id = id;
        this.name = name;
        this.html = html;
        this.options = options;
        this.company_id = company_id;
    }
}

export class Configuration {
    company_id: number;
    name: string;
    path: any;
    path_url: string;
    footer: string;
    footer_small: string;
    tax_type: string;
    sequences: Sequence[];
    email_template: EmailTemplate;
    invoice_template: InvoiceTemplate | null;
    hide_client_send_to_face: boolean;
    hide_client_send_to_faceb2b: boolean;
    hide_client_send_to_accounting: boolean;
    personalization_id: number;
    alias: string;
    auto_send_to_verifactu: boolean;
    remittance_only_iban: boolean;

    constructor(
        company_id: number = null,
        name: string = '',
        alias: string = '',
        path: any = null,
        path_url: string = '',
        footer: string = '',
        footer_small: string = '',
        tax_type: string = 'iva',
        sequences: Sequence[] = [new Sequence()],
        email_template: EmailTemplate = new EmailTemplate(),
        invoice_template: InvoiceTemplate | null = null,
        hide_client_send_to_face: boolean = false,
        hide_client_send_to_faceb2b: boolean = false,
        hide_client_send_to_accounting: boolean = false,
        personalization_id: number = 0,
        auto_send_to_verifactu: boolean = false,
        remittance_only_iban: boolean = false

    ){
        this.company_id = company_id;
        this.name = name;
        this.alias = alias;
        this.path = path;
        this.path_url = path_url;
        this.footer = footer;
        this.footer_small = footer_small;
        this.tax_type = tax_type;
        this.sequences = sequences;
        this.email_template = email_template;
        this.invoice_template = invoice_template;
        this.hide_client_send_to_face = hide_client_send_to_face;
        this.hide_client_send_to_faceb2b = hide_client_send_to_faceb2b;
        this.hide_client_send_to_accounting = hide_client_send_to_accounting;
        this.personalization_id = personalization_id;
        this.auto_send_to_verifactu = auto_send_to_verifactu;
        this.remittance_only_iban = remittance_only_iban;
    }
}